import { render, staticRenderFns } from "./AttachIdentificationDocument.vue?vue&type=template&id=6f99d89b&"
import script from "./AttachIdentificationDocument.vue?vue&type=script&lang=js&"
export * from "./AttachIdentificationDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports